import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTecnicoResponsableState
} from './entity-tecnico-responsable.state';
import { entityTecnicoResponsableAdapter } from './entity-tecnico-responsable.state';
import {
  entityTecnicoResponsableLoadRequest,
  entityTecnicoResponsableLoadSuccess,
  entityTecnicoResponsableLoadFailure,
  entityTecnicoResponsableAddFailure,
  entityTecnicoResponsableAddRequest,
  entityTecnicoResponsableAddSuccess,
  entityTecnicoResponsableChangeFailure,
  entityTecnicoResponsableChangeRequest,
  entityTecnicoResponsableChangeSuccess,
  entityTecnicoResponsableDeleteFailure,
  entityTecnicoResponsableDeleteRequest,
  entityTecnicoResponsableDeleteSuccess
} from './entity-tecnico-responsable.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTecnicoResponsableLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTecnicoResponsableLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTecnicoResponsableLoadSuccess, (state, { items }) =>
    entityTecnicoResponsableAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityTecnicoResponsableAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTecnicoResponsableAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTecnicoResponsableAddSuccess, (state, { item }) =>
    entityTecnicoResponsableAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityTecnicoResponsableChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTecnicoResponsableChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTecnicoResponsableChangeSuccess, (state, { item }) =>
    entityTecnicoResponsableAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityTecnicoResponsableDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTecnicoResponsableDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTecnicoResponsableDeleteSuccess, (state, { item }) =>
    entityTecnicoResponsableAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function tecnicoResponsableReducer(
  state: EntityTecnicoResponsableState | undefined,
  action: Action
) {
  return reducer(state, action);
}
